import React, { useEffect, useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import api, { ADMIN_TOKEN_KEY } from "../../api";
import { LayoutDashboard, Library, BookOpen, MessagesSquare, Sparkles, NotebookPen,
         Users, Wand2, FileSpreadsheet, LogOut, Eye, Compass, Video, IndianRupee } from "lucide-react";

const NAV = [
  { to: "/admin", icon: LayoutDashboard, label: "Dashboard", end: true },
  { to: "/admin/themes", icon: Library, label: "Themes" },
  { to: "/admin/content/lessons", icon: BookOpen, label: "Weekly Content" },
  { to: "/admin/scenarios", icon: Compass, label: "Journey Scenarios" },
  { to: "/admin/jidnyasa", icon: Video, label: "JJLP Live" },
  { to: "/admin/pricing", icon: IndianRupee, label: "Pricing" },
  { to: "/admin/prompts", icon: Wand2, label: "AI Prompts" },
  { to: "/admin/users", icon: Users, label: "Users" },
  { to: "/admin/preview", icon: Eye, label: "Preview" },
  { to: "/admin/uploads", icon: FileSpreadsheet, label: "Uploads" },
];

export default function AdminLayout() {
  const nav = useNavigate();
  const [me, setMe] = useState(null);

  useEffect(() => {
    api.get("/admin/auth/me").then((r) => setMe(r.data)).catch(() => nav("/admin/login"));
  }, [nav]);

  const logout = () => {
    localStorage.removeItem(ADMIN_TOKEN_KEY);
    nav("/admin/login");
  };

  return (
    <div className="min-h-screen flex bg-[hsl(var(--neu-paper))]">
      <aside className="hidden lg:flex w-64 shrink-0 flex-col bg-[hsl(var(--neu-ink))] text-white p-5">
        <div className="font-display text-2xl mb-1">NeuroEQ</div>
        <div className="text-xs uppercase tracking-widest text-white/60 mb-8">Admin CMS</div>
        <nav className="flex-1 space-y-1">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end}
                      className={({ isActive }) => `flex items-center gap-3 px-3 py-2 rounded-xl text-sm transition-colors ${
                        isActive ? "bg-white/10" : "hover:bg-white/5"
                      }`}
                      data-testid={`admin-nav-${n.label.toLowerCase().replace(/\s/g, '-')}`}>
              <n.icon className="w-4 h-4"/> {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="mt-6 pt-6 border-t border-white/10">
          <div className="text-xs text-white/60 mb-1">{me?.email}</div>
          <button onClick={logout} className="text-xs flex items-center gap-2 text-white/70 hover:text-white"
                  data-testid="admin-logout-btn">
            <LogOut className="w-3 h-3"/> Sign out
          </button>
        </div>
      </aside>

      {/* Mobile top bar */}
      <div className="lg:hidden fixed top-0 inset-x-0 bg-[hsl(var(--neu-ink))] text-white px-4 py-3 z-30 flex items-center gap-3 overflow-x-auto">
        <div className="font-display text-lg shrink-0">NeuroEQ Admin</div>
        {NAV.map((n) => (
          <NavLink key={n.to} to={n.to} end={n.end}
                    className={({ isActive }) => `text-xs px-3 py-1 rounded-full shrink-0 ${
                      isActive ? "bg-white text-[hsl(var(--neu-ink))]" : "bg-white/10"
                    }`}>{n.label}</NavLink>
        ))}
      </div>

      <main className="flex-1 p-6 lg:p-10 pt-20 lg:pt-10 overflow-x-hidden">
        <Outlet />
      </main>
    </div>
  );
}
